module.exports = __webpack_public_path__ + "images/rich_heading/hobby_fashion/plamodel/icon_968f24aa39d81b6bf4ccc6cb9308057a.png";